import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useCategoryAPI() {
  const { languageRef } = useStorage();

  function loadCategoryFromRemote(id) {
    const url = `/vbeta2/menu/categories/${id}`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    loadCategoryFromRemote,
  };
}

export { useCategoryAPI };
